import { AttachmentsDialog, useAnexoFinanceiro, useFaturasStore, AnexoFinanceiroIdentificador } from "@FN";
import { useMemo } from "react";

interface AnexosFaturaProps {
  mode?: "inclusao" | "edicao" | "visualizar";
}

export function AnexosFatura({ mode }: AnexosFaturaProps) {
  const faturaZ15 = useFaturasStore((s) => s.faturaZ15);
  
  // Constrói o identificador para buscar anexos (memoizado para evitar loops)
  const identificador: AnexoFinanceiroIdentificador | null = useMemo(() => {
    return faturaZ15 ? {
      filial: faturaZ15.Z15_FILIAL,
      fornecedor: faturaZ15.Z15_FORNEC,
      loja: faturaZ15.Z15_LOJA,
      cod: faturaZ15.Z15_COD,
    } : null;
  }, [faturaZ15]);
  
  const { isFetching } = useAnexoFinanceiro(identificador);
  
  return (
    <>
      <AttachmentsDialog 
        className={`w-78 h-9 ${mode === "visualizar" ? "pointer-events-none opacity-50" : ""}`}
        tipo="financeiro" 
        loading={isFetching} />
    </>
  );
}